var cov_g2wz3p6lr = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tag/Input.tsx",
      hash = "630795a7887b8b5db20cc90066df109c7fd008f8",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tag/Input.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 16
        }
      },
      "1": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 42
        }
      },
      "2": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 52
        }
      },
      "3": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 48
        }
      },
      "4": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 50
        }
      },
      "5": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 29
        }
      },
      "6": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 42
        }
      },
      "7": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 20,
          column: 42
        }
      },
      "8": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 21
        }
      },
      "9": {
        start: {
          line: 28,
          column: 22
        },
        end: {
          line: 28,
          column: 30
        }
      },
      "10": {
        start: {
          line: 29,
          column: 25
        },
        end: {
          line: 29,
          column: 35
        }
      },
      "11": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 33
        }
      },
      "12": {
        start: {
          line: 30,
          column: 18
        },
        end: {
          line: 30,
          column: 33
        }
      },
      "13": {
        start: {
          line: 34,
          column: 46
        },
        end: {
          line: 34,
          column: 56
        }
      },
      "14": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 38,
          column: 5
        }
      },
      "15": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 37,
          column: 86
        }
      },
      "16": {
        start: {
          line: 36,
          column: 24
        },
        end: {
          line: 36,
          column: 55
        }
      },
      "17": {
        start: {
          line: 37,
          column: 11
        },
        end: {
          line: 37,
          column: 86
        }
      },
      "18": {
        start: {
          line: 37,
          column: 23
        },
        end: {
          line: 37,
          column: 86
        }
      },
      "19": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 27
        }
      },
      "20": {
        start: {
          line: 39,
          column: 17
        },
        end: {
          line: 39,
          column: 27
        }
      },
      "21": {
        start: {
          line: 43,
          column: 23
        },
        end: {
          line: 43,
          column: 33
        }
      },
      "22": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 41
        }
      },
      "23": {
        start: {
          line: 44,
          column: 16
        },
        end: {
          line: 44,
          column: 41
        }
      },
      "24": {
        start: {
          line: 48,
          column: 31
        },
        end: {
          line: 48,
          column: 41
        }
      },
      "25": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 60,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 36
          },
          end: {
            line: 16,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 22
          },
          end: {
            line: 21,
            column: 3
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        loc: {
          start: {
            line: 23,
            column: 32
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 23
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 55
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 27
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 93
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 33
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 52
          },
          end: {
            line: 45,
            column: 3
          }
        },
        line: 42
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        },
        loc: {
          start: {
            line: 47,
            column: 11
          },
          end: {
            line: 61,
            column: 3
          }
        },
        line: 47
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 42
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 42
          }
        }],
        line: 20
      },
      "1": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 33
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 33
          }
        }],
        line: 30
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 37,
            column: 86
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 37,
            column: 86
          }
        }, {
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 37,
            column: 86
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 37,
            column: 11
          },
          end: {
            line: 37,
            column: 86
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 11
          },
          end: {
            line: 37,
            column: 86
          }
        }, {
          start: {
            line: 37,
            column: 11
          },
          end: {
            line: 37,
            column: 86
          }
        }],
        line: 37
      },
      "5": {
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 27
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 27
          }
        }],
        line: 39
      },
      "6": {
        loc: {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 41
          }
        }, {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 41
          }
        }],
        line: 44
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tag/Input.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import inputBorder from '../hoc/inputBorder';
import { tagClass } from './styles';

var TagInput =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TagInput, _PureComponent);

  var _super = _createSuper2(TagInput);

  function TagInput(props) {
    var _this;

    _classCallCheck(this, TagInput);

    cov_g2wz3p6lr.f[0]++;
    cov_g2wz3p6lr.s[0]++;
    _this = _super.call(this, props);
    _this.element = void 0;
    cov_g2wz3p6lr.s[1]++;
    _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_this));
    cov_g2wz3p6lr.s[2]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    cov_g2wz3p6lr.s[3]++;
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    cov_g2wz3p6lr.s[4]++;
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TagInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_g2wz3p6lr.f[1]++;
      cov_g2wz3p6lr.s[5]++;

      _get(_getPrototypeOf(TagInput.prototype), "componentDidMount", this).call(this);

      cov_g2wz3p6lr.s[6]++;

      if (this.element) {
        cov_g2wz3p6lr.b[0][0]++;
        cov_g2wz3p6lr.s[7]++;
        this.element.focus();
      } else {
        cov_g2wz3p6lr.b[0][1]++;
      }
    }
  }, {
    key: "bindRef",
    value: function bindRef(el) {
      cov_g2wz3p6lr.f[2]++;
      cov_g2wz3p6lr.s[8]++;
      this.element = el;
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      cov_g2wz3p6lr.f[3]++;

      var _ref = (cov_g2wz3p6lr.s[9]++, e.target),
          value = _ref.value;

      var _ref2 = (cov_g2wz3p6lr.s[10]++, this.props),
          onChange = _ref2.onChange;

      cov_g2wz3p6lr.s[11]++;

      if (onChange) {
        cov_g2wz3p6lr.b[1][0]++;
        cov_g2wz3p6lr.s[12]++;
        onChange(value);
      } else {
        cov_g2wz3p6lr.b[1][1]++;
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(e) {
      cov_g2wz3p6lr.f[4]++;

      var _ref3 = (cov_g2wz3p6lr.s[13]++, this.props),
          onBlur = _ref3.onBlur,
          onKeyUp = _ref3.onKeyUp,
          onEnterPress = _ref3.onEnterPress;

      cov_g2wz3p6lr.s[14]++;

      if (e.keyCode === 13) {
        cov_g2wz3p6lr.b[2][0]++;
        cov_g2wz3p6lr.s[15]++;

        if (onEnterPress) {
          cov_g2wz3p6lr.b[3][0]++;
          cov_g2wz3p6lr.s[16]++;
          onEnterPress(e.target.value, e);
        } else {
          cov_g2wz3p6lr.b[3][1]++;
          cov_g2wz3p6lr.s[17]++;

          if (onBlur) {
            cov_g2wz3p6lr.b[4][0]++;
            cov_g2wz3p6lr.s[18]++;
            onBlur(e.target.value, e);
          } else {
            cov_g2wz3p6lr.b[4][1]++;
          }
        }
      } else {
        cov_g2wz3p6lr.b[2][1]++;
      }

      cov_g2wz3p6lr.s[19]++;

      if (onKeyUp) {
        cov_g2wz3p6lr.b[5][0]++;
        cov_g2wz3p6lr.s[20]++;
        onKeyUp(e);
      } else {
        cov_g2wz3p6lr.b[5][1]++;
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      cov_g2wz3p6lr.f[5]++;

      var _ref4 = (cov_g2wz3p6lr.s[21]++, this.props),
          onBlur = _ref4.onBlur;

      cov_g2wz3p6lr.s[22]++;

      if (onBlur) {
        cov_g2wz3p6lr.b[6][0]++;
        cov_g2wz3p6lr.s[23]++;
        onBlur(e.target.value, e);
      } else {
        cov_g2wz3p6lr.b[6][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_g2wz3p6lr.f[6]++;

      var _ref5 = (cov_g2wz3p6lr.s[24]++, this.props),
          value = _ref5.value,
          onFocus = _ref5.onFocus;

      cov_g2wz3p6lr.s[25]++;
      return (
        /*#__PURE__*/
        React.createElement("input", {
          ref: this.bindRef,
          type: "text",
          value: value,
          onFocus: onFocus,
          onChange: this.handleChange,
          onKeyUp: this.handleKeyUp,
          onBlur: this.handleBlur,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 51,
            columnNumber: 7
          }
        })
      );
    }
  }]);

  return TagInput;
}(PureComponent);

export default inputBorder({
  className: tagClass('input')
})(TagInput);